import {krazki} from '../krazki'

const initialState = krazki;

export default (state = initialState, action = {}) => {
    return state;
};


// WEBPACK FOOTER //
// ./src/state/krazki.js